export default "__VITE_ASSET__d0ffd7a8__"